// Support-bridge config for the nav gate + Support page vocabulary.
// Module-scope cache: fetched once per session, shared by every consumer
// (AppLayout's nav entry + SupportPage) — per the multi-consumer-hook
// convention in src/CLAUDE.md.
import { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { support } from '@/lib/trackizy';

const DISABLED = { enabled: false, provider: 'off', categories: [], priorities: [] };

let cached = null;
let inflight = null;
const listeners = new Set();

function notify() {
  for (const fn of listeners) fn();
}

async function load() {
  if (cached || inflight) return;
  inflight = support
    .config()
    .then((res) => {
      cached = res && typeof res.enabled === 'boolean' ? res : DISABLED;
    })
    .catch(() => {
      cached = DISABLED;
    })
    .finally(() => {
      inflight = null;
      notify();
    });
}

export default function useSupportConfig() {
  const [, forceUpdate] = useReducer((n) => n + 1, 0);
  // The enterprise view has no organization: /api/support/* is org-scoped
  // (requireOrg) and the nav entry is not shown there, so nothing is fetched
  // and nothing is cached (leaving enterprise mode still loads it).
  const enterpriseMode = useSelector((state) => state.org?.enterprise === true);
  useEffect(() => {
    listeners.add(forceUpdate);
    if (!enterpriseMode) load();
    return () => listeners.delete(forceUpdate);
  }, [enterpriseMode]);
  if (enterpriseMode) return DISABLED;
  return cached ?? DISABLED;
}
